var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as EventGroupArtist from './EventGroupArtist';
import { gql } from '@apollo/client/core';
import { COLLECTION_METADATA_FIELDS } from "../collection/Api";
import * as GqlCollection from "../collection/GqlCollection";
import { ARTIST_FIELDS } from "../Artist/Api";
const EVENT_ARTISTS_QUERY = gql `
  query EventGroupArtists($eventGroupId: Int!, $page: Int, $limit: Int) {
    app {
      eventGroupArtists(eventGroupId: $eventGroupId, page: $page, limit: $limit) {
        collection {
          id
          eventGroupId
          artist {
            ...ArtistFields
          }
        }
        metadata {
          ...CollectionMetadataFields
        }
      }
    }
  }
  ${COLLECTION_METADATA_FIELDS}
  ${ARTIST_FIELDS}
`;
export const fetchEventGroupArtists = (client_1, eventGroupId_1, ...args_1) => __awaiter(void 0, [client_1, eventGroupId_1, ...args_1], void 0, function* (client, eventGroupId, collectionArguments = {}) {
    const { data } = yield client.query({
        query: EVENT_ARTISTS_QUERY,
        variables: Object.assign(Object.assign({}, collectionArguments), { eventGroupId }),
    });
    return GqlCollection.fromGql(data.app.eventGroupArtists, EventGroupArtist.fromGqlCollection);
});
const ADD_EVENT_ARTISTS_MUTATION = gql `
  mutation AddEventGroupArtist($eventGroupId: Int!, $artist: ArtistInput!) {
    app {
      addEventGroupArtist(input: { eventGroupId: $eventGroupId, artist: $artist}) {
        eventGroupArtist {
          id
          artistId
          eventGroupId
          artist {
            ...ArtistFields
          }
        }
        clientMutationId
        errors
        success
      }
    }
  }
  ${ARTIST_FIELDS}
`;
export const addEventGroupArtist = (client, addParams) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: ADD_EVENT_ARTISTS_MUTATION,
        variables: Object.assign({}, addParams),
        update: cache => {
            cache.evict({
                id: 'ROOT_QUERY',
                // Probably needs better cache clearing
                fieldName: 'app',
            });
            cache.gc();
        },
    });
    const response = data.app.addEventGroupArtist;
    if (response.success) {
        return {
            success: true,
            data: EventGroupArtist.fromGql(response),
        };
    }
    return {
        success: false,
        errors: response.errors,
    };
});
//# sourceMappingURL=Api.js.map